@if (selectedDeclaration().invoices?.length) {
  <div class="card" id="costs">
    <div class="card-body p-5">
      <div class="h1 mb-2">Costs (invoice)</div>
      <div class="row g-4">
        @for (invoice of selectedDeclaration().invoices; track invoice.url) {
          <div class="col-6 d-flex flex-column justify-content-center">
            <div>
              {{ invoice.invoiceNumber }} ({{ invoice.invoiceType | lowercase}}) - v{{ invoice.statementVersion }}
            </div>
            <div>
              Retrieved on {{invoice.receivedTimestamp | date:'dd MMM yyyy, HH:mm' }}
            </div>
          </div>

          <div class="col-6 always-enabled">
            <button type="button" class="btn btn-outline-primary" (click)="downloadPdf(invoice) ">
              <i class="fa-solid fa-download me-2"></i>
              <span>Download PDF</span>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}

